import React, { useRef, useState } from "react";
import { api } from "../../../lib/api";
import { imgSrc } from "../../../lib/content";
import { toast } from "sonner";
import { Upload, Plus, Trash2 } from "lucide-react";

export async function uploadImage(file) {
  const fd = new FormData(); fd.append("file", file);
  const { data } = await api.post("/admin/upload", fd);
  return data.url;
}

export function TextField({ field, value, onChange }) {
  const Tag = field.type === "textarea" ? "textarea" : "input";
  return (
    <div>
      <div className="label-mono mb-1">{field.label}</div>
      <Tag value={value || ""} onChange={e=>onChange(e.target.value)} rows={field.type === "textarea" ? 3 : undefined}
        className="input-dark resize-y" data-testid={`content-${field.key}`}/>
    </div>
  );
}

export function ImageField({ field, value, onChange }) {
  const input = useRef(null);
  const [busy, setBusy] = useState(false);
  const onFile = async (f) => {
    if (!f) return;
    setBusy(true);
    try { onChange(await uploadImage(f)); toast.success("Immagine caricata — ricordati di salvare"); }
    catch (e) { toast.error(e.response?.data?.detail || "Errore upload"); }
    finally { setBusy(false); if (input.current) input.current.value = ""; }
  };
  return (
    <div>
      <div className="label-mono mb-1">{field.label}</div>
      <div className="flex gap-3 items-center">
        {value && <img src={imgSrc(value)} alt="" className="w-20 h-14 object-cover border border-neutral-800" data-testid={`content-${field.key}-preview`}/>}
        <input value={value || ""} onChange={e=>onChange(e.target.value)} placeholder="https://... oppure carica"
          className="input-dark font-mono text-xs flex-1" data-testid={`content-${field.key}`}/>
        <input ref={input} type="file" accept="image/*" className="hidden" onChange={e=>onFile(e.target.files[0])} data-testid={`content-${field.key}-file`}/>
        <button type="button" onClick={()=>input.current.click()} disabled={busy} className="btn-ghost !py-2 !px-3 text-[10px] flex items-center gap-1" data-testid={`content-${field.key}-upload`}>
          <Upload className="w-3 h-3"/>{busy ? "..." : "CARICA"}
        </button>
      </div>
    </div>
  );
}

export function ListField({ field, value, onChange }) {
  const items = value || [];
  const set = (i, name, v) => onChange(items.map((it, j) => j === i ? { ...it, [name]: v } : it));
  const empty = Object.fromEntries(field.fields.map(f => [f.name, ""]));
  return (
    <div>
      <div className="label-mono mb-2">{field.label}</div>
      <div className="space-y-3">
        {items.map((it, i) => (
          <div key={i} className="border border-neutral-800 p-3 flex gap-3 items-start" data-testid={`content-${field.key}-item-${i}`}>
            <div className="grid md:grid-cols-3 gap-3 flex-1">
              {field.fields.map(f => (
                <div key={f.name} className={f.wide ? "md:col-span-3" : ""}>
                  <div className="label-mono text-[9px] mb-1">{f.label}</div>
                  <input value={it[f.name] || ""} onChange={e=>set(i, f.name, e.target.value)} className="input-dark text-sm"
                    data-testid={`content-${field.key}-${i}-${f.name}`}/>
                </div>
              ))}
            </div>
            <button type="button" onClick={()=>onChange(items.filter((_, j) => j !== i))} className="text-alert p-2" aria-label="Rimuovi"
              data-testid={`content-${field.key}-remove-${i}`}><Trash2 className="w-4 h-4"/></button>
          </div>
        ))}
      </div>
      <button type="button" onClick={()=>onChange([...items, empty])} className="btn-ghost !py-2 !px-3 text-[10px] mt-3 flex items-center gap-1"
        data-testid={`content-${field.key}-add`}><Plus className="w-3 h-3"/>AGGIUNGI</button>
    </div>
  );
}

export function FieldInput(props) {
  if (props.field.type === "image") return <ImageField {...props}/>;
  if (props.field.type === "list") return <ListField {...props}/>;
  return <TextField {...props}/>;
}
